import { lazy } from 'react';

import { withLoader } from '@perpay-web/components/higher-order/WithLoader/WithLoader';
import { importSpendingLimitAnimation } from '@perpay-web/fintech/utils/imports/importSpendingLimitAnimation';

export default withLoader(lazy(importSpendingLimitAnimation));
